import { render } from "./ShowSubject.vue?vue&type=template&id=581e7df4"
import script from "./ShowSubject.vue?vue&type=script&lang=js"
export * from "./ShowSubject.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__